import { css } from '@emotion/css';

import { AvatarSize } from './types';

export const AVATAR_SIZE_MAP: Record<AvatarSize, number> = {
  large: 32,
  medium: 28,
  small: 24,
  'x-large': 40,
  'x-small': 20,
  'xx-large': 48,
};

export const BADGE_BACKGROUND_COLOR_MAP = {
  offline: 'bg-icon-placeholder',
  online: 'bg-icon-success',
};

export const BADGE_POSITION_MAP: Record<AvatarSize, string> = {
  large: 'bottom-2 end-2',
  medium: 'bottom-2 end-2',
  small: 'end-1 bottom-1',
  'x-large': 'bottom-2 end-2',
  'x-small': 'end-1 bottom-1',
  'xx-large': 'bottom-2 end-2',
};

export const getAvatarSizeClassName = (size: AvatarSize) => {
  if (Number.isInteger(size)) {
    return avatarSize(size as number);
  }
  return avatarSize(AVATAR_SIZE_MAP[size]);
};

export const badgeStyleMap = (size: AvatarSize) => {
  if (Number.isInteger(size)) {
    return badgeStyle(size as number);
  }
  return badgeStyle(AVATAR_SIZE_MAP[size]);
};

const avatarSize = (size: number) => css`
  width: ${size}px;
  height: ${size}px;
`;

const badgeStyle = (size: number) => css`
  ${avatarSize(size / 4)}
`;
